import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import UpcomingShows from "@/components/UpcomingShows";
import CTABand from "@/components/CTABand";
import { useLang } from "@/lib/i18n";

export default function CalendarPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "演出日历 — DFE 娛樂夢工廠" : "Upcoming Shows — Dream Factory Entertainment"}
        description={lang === "zh" ? "DFE 即将举行的演唱会与音乐节档期，一手掌握开票信息。" : "Upcoming DFE concerts and festivals — dates, venues and ticket links."}
      />
      <NavBar />
      <main className="pt-16">
        <UpcomingShows />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
